module.exports = __webpack_public_path__ + "static/media/data.fdff6fec.png";